module.exports = __webpack_public_path__ + "807ee2fc0ff608d7.svg";